export const MEETING_INTELLIGENCE_ADDONS = [
  'meeting-intelligence-standard-monthly-usd',
  'meeting-intelligence-standard-yearly-usd',
  'meeting-intelligence-teams-monthly-usd',
  'meeting-intelligence-teams-yearly-usd',
  'meeting-intelligence-enterprise-yearly-usd',
]

export const MEETING_INSIGHTS_BETA_ADDONS = [
  'meeting-insights-early-access-monthly-usd',
  'meeting-insights-early-access-yearly-usd',
  'meeting-recaps-early-access-monthly-usd',
  'meeting-recaps-early-access-yearly-usd'
]

export const addonsForMeetingIntelligencePlan = ({ tier, billingPeriod }) => {
  if (billingPeriod === 'month') {
    if (tier === 'standard') return ['meeting-intelligence-standard-monthly-usd']
    if (tier === 'teams') return ['meeting-intelligence-teams-monthly-usd']
    if (tier === 'enterprise') return ['meeting-intelligence-enterprise-monthly-usd']
  }

  if (tier === 'standard') return ['meeting-intelligence-standard-yearly-usd']
  if (tier === 'teams') return ['meeting-intelligence-teams-yearly-usd']
  if (tier === 'enterprise') return ['meeting-intelligence-enterprise-yearly-usd']

  return []
}

export const MEETING_INTELLIGENCE_FEATURES = [
  'meeting_intelligence',
  'meeting_intelligence_create_snippets',
  'meeting_intelligence_custom_text',
  'meeting_intelligence_nonfree',
  'meeting_intelligence_retention_infinite',
  'meeting_intelligence_search_qa',
  'meeting_intelligence_send_from_user_email',
  'meeting_intelligence_collaboration',
  'meeting_intelligence_hubspot',
  'meeting_intelligence_salesforce',
  'meeting_intelligence_vertical_frameworks'
]
